export default __webpack_public_path__ + "static/media/order.a960cc2d.svg";